import {
  ai,
  appointments,
  competitions,
  createClient,
  episodes,
  files,
  gifts,
  invoices,
  notifications,
  packages,
  patients,
  pricing,
  readModels,
  tasks,
  visits,
} from "@bezbolisno/contracts";
import { env } from "../env";

const options = { baseUrl: env.VITE_API_URL };

/** One typed client per context — the only way the SPA talks to the API. */
export const api = {
  patients: createClient(patients, options),
  episodes: createClient(episodes, options),
  visits: createClient(visits, options),
  ai: createClient(ai, options),
  tasks: createClient(tasks, options),
  files: createClient(files, options),
  competitions: createClient(competitions, options),
  appointments: createClient(appointments, options),
  pricing: createClient(pricing, options),
  packages: createClient(packages, options),
  invoices: createClient(invoices, options),
  gifts: createClient(gifts, options),
  readModels: createClient(readModels, options),
  notifications: createClient(notifications, options),
};

/** Throw a typed error for a non-success response so `useQuery`/`useMutation` surface it. */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    readonly problem: unknown,
  ) {
    super(`${status} ${code}`);
    this.name = "ApiError";
  }
}

export function expectOk<T extends { status: number; body: unknown }, S extends T["status"]>(
  res: T,
  ...ok: S[]
): Extract<T, { status: S }>["body"] {
  if ((ok as number[]).includes(res.status)) return res.body as Extract<T, { status: S }>["body"];
  const problem = res.body as { code?: string } | undefined;
  throw new ApiError(res.status, problem?.code ?? "unknown", res.body);
}
